<template>
    <transition name="fav" mode="out-in">
        <span
            class="icon icon-fav"
            @click.stop="onClick"
            v-if="likeState"
            key="onFav"
        ></span>
        <span
            class="icon icon-no-fav"
            @click.stop="onClick"
            v-if="!likeState"
            key="offFav"
        ></span>
    </transition>
</template>

<script>
export default {
    name: 'LikeMark',
    props: {
        liked: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            likeState: {
                type: Boolean,
                default: false,
            },
        }
    },
    created: function(){
        this.likeState = this.liked
    },
    methods: {
        onClick: function () {
            this.likeState = !this.likeState
            if (this.likeState) {
                this.$emit('liked')
            } else {
                this.$emit('unliked')
            }
        },
    },
}
</script>

<style scoped>
.fav-enter-active,
.fav-leave-acrive {
    transition: all 0.3s ease;
}
.fav-enter,
.fav-leave-to {
    opacity: 0;
}
.icon {
    width: 20px;
    height: 20px;
    background-size: contain;
}
.icon-fav {
    background-image: url('../assets/fav1.png');
}
.icon-no-fav {
    background-image: url('../assets/fav2.png');
}
</style>
